import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * Android hardware back: go to previous SPA history entry when possible;
 * otherwise send the app to background (same as typical "minimize").
 */
export default function AndroidBackButtonHandler() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
      return undefined;
    }

    let cancelled = false;
    let handle = null;

    App.addListener('backButton', async ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
        return;
      }
      try {
        await App.minimizeApp();
      } catch (e) {
        console.warn('minimizeApp failed:', e);
      }
    })
      .then((h) => {
        if (cancelled) {
          Promise.resolve(h?.remove?.()).catch(() => {});
        } else {
          handle = h;
        }
      })
      .catch((e) => console.warn('Android back button listener failed:', e));

    return () => {
      cancelled = true;
      Promise.resolve(handle?.remove?.()).catch(() => {});
    };
  }, []);

  return null;
}
